module.exports = __webpack_public_path__ + "img/202405_02.426fa558.jpg";